import { createStore } from 'redux';
import reducers, { initialState } from './reducers';

// eslint-disable-next-line import/prefer-default-export
export const store = createStore(
  reducers,
  initialState,
);
